import React from 'react';
import PropTypes from 'prop-types';

export const Filter = ({ width, height, ...props }) => (
  <svg
    data-icon='filter'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M11.001 20a.967.967 0 0 1-.712-.288A.968.968 0 0 1 10 19v-6l-5.8-7.4c-.25-.333-.287-.683-.112-1.05S4.568 4 5 4h14c.433 0 .738.183.913.55.175.367.137.717-.113 1.05l-5.8 7.4v6c0 .283-.096.52-.287.712A.968.968 0 0 1 13 20h-2Zm1-7.7 4.95-6.3h-9.9l4.95 6.3Z'
    />
  </svg>
);

Filter.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Filter.defaultProps = {
  width: 24,
  height: 24,
};
